import React from "react";
import "./style.css";

function Jumbotron() {
  return (
    <div className="jumbotron jumbotron-fluid text-center nav-jumbo">
      <div className="container">
        <p className="lead"><span>Search for Software and Web Development Jobs</span><br /><span>(with Higher Relevance and Less Noise)</span></p>
      </div>
    </div>
  );
}

export default Jumbotron;
